import React from 'react';

function Wikimage({ src, alt }) {
  return (
    <div>
      <img src={src} alt={alt} />
    </div>
  );
}

export default Wikimage;
